import React, { memo, forwardRef } from 'react';
import cn from 'classnames';
import { Box } from '../box';
import styles from './styles.module.css';
const RADIUS = {
    l: '24px',
    m: '16px',
    none: undefined,
};
export const Paper = memo(forwardRef(function Paper({ className, radius = 'l', style, ...props }, ref) {
    const finalStyle = { ...style, ['--border-radius']: RADIUS[radius] };
    return React.createElement(Box, { ref: ref, className: cn(className, styles.paper), style: finalStyle, ...props });
}));
